import axios from "axios";
import { authHeader } from "./auth-header";
import { ENV } from "../config/env";
import responseHandler from "./server-response-handler";
import {
  HTTP_METHODS,
  HTTP_HEADER_NAMES,
  HTTP_CONTENT_TYPES,
  AUTHORIZATION_SCHEME,
} from "../constants";

const buildURL = (url) => {
  const baseUrl = ENV.BASE_URL;
  return baseUrl + url;
};

const buildHeaders = (auth, isFormData = false) => {
  let headers = {
    [HTTP_HEADER_NAMES.CONTENT_TYPE]: isFormData
      ? HTTP_CONTENT_TYPES.FORM_DATA
      : HTTP_CONTENT_TYPES.JSON,
    [HTTP_HEADER_NAMES.ACCEPT]: HTTP_CONTENT_TYPES.JSON,
  };

  if (auth === true) {
    headers = { ...headers, ...authHeader() };
  }

  return headers;
};

const sendRequest = (url, requestOptions) => {
  axios.defaults.withCredentials = false;
  return axios(buildURL(url), requestOptions);
};

// Keep service errors intact when turning a request into its result.
const handleRequest = (
  request,
  onSuccess = responseHandler.handleServerResponse
) =>
  request.then(onSuccess, (error) =>
    responseHandler.handleHTTPResponses(error?.response)
  );

const getRequest = (url, auth = true, token = null) => {
  const headers = buildHeaders(auth);
  if (token) {
    headers[HTTP_HEADER_NAMES.AUTHORIZATION] = `${AUTHORIZATION_SCHEME} ${token}`;
  }

  return sendRequest(url, {
    method: HTTP_METHODS.GET,
    headers: headers,
  });
};

const deleteRequest = (url, auth = true) =>
  sendRequest(url, {
    method: HTTP_METHODS.DELETE,
    headers: buildHeaders(auth),
  });

const postRequest = (url, dataObj, auth = true) =>
  sendRequest(url, {
    method: HTTP_METHODS.POST,
    headers: buildHeaders(auth),
    data: dataObj,
  });

const putRequest = (url, dataObj, auth = true) =>
  sendRequest(url, {
    method: HTTP_METHODS.PUT,
    headers: buildHeaders(auth),
    data: JSON.stringify(dataObj),
  });

const formDataPutRequest = (url, dataObj, auth = true) =>
  sendRequest(url, {
    method: HTTP_METHODS.PUT,
    headers: buildHeaders(auth, true),
    data: dataObj,
  });

export {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  handleRequest,
  formDataPutRequest,
};
